import { createCrudModule } from "../crud";

export function testimonialListing(response) {
  const envelope = response?.data;
  const data = envelope?.testimonial_responses || envelope?.responses || envelope?.testimonials || envelope;
  const rows = Array.isArray(data) ? data : data?.data || data?.items || [];
  if (!Array.isArray(rows)) throw new Error("The testimonial response is invalid.");
  return { rows, total: data?.total ?? rows.length, lastPage: data?.last_page ?? 1 };
}

export default createCrudModule({
  name: "testimonialResponses",
  stateKey: "TestimonialResponses",
  endpoint: "testimonials",
  operations: {
    list: {
      query: ({ page = 1, length = 10, search = "", status = "" } = {}) => ({ paginate: page, size: length, search, status }),
      select: testimonialListing,
    },
    details: false,
    create: false,
  },
});
